import Helpers from '../../common/helpers/Helpers';
import Constants from '../../common/constants/Constants';

export const getChatSessions = () => {
  return Helpers.get(`${Constants.CHAT_URL}/sessions`);
};

export const logChatAction = (chatAction, correlationId, serialNumber) => {
  let query = {
    chatAction: chatAction,
    correlationId: correlationId,
    serialNumber: serialNumber
  };

  return Helpers.get(`${Constants.CHAT_URL}/actions`, {}, query);
};
